export default __webpack_public_path__ + "static/media/category-icon.62134c98.svg";